<template>
  <div>
    <a href="#" @click.prevent="dialog = true"><v-icon color="primary">mdi-information</v-icon> What does Comprehensive Insurance Cover?</a>
    <v-dialog
        v-model="dialog"
        width="500"
    >
      <v-card class="tw-px-2">
        <card-title>Comprehensive Insurance Cover</card-title>
        <v-card-text class="tw-mt-5">
          Comprehensive standard motor cover protects the Insured from any loss occurring due to Accidental Damage to the motor vehicle, its accessories and spare parts, Fire, Theft and Liability wherever Insured may be legally liable to pay, covering the Third-Party bodily injury & property damage.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';

export default {
  name: 'WhatIsComprehensive',
  components: { CardTitle },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
